import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "show", "className", "duration", "onEntered", "onExited"];

/* eslint no-param-reassign: 0 */
import React from 'react';
import cn from 'classnames';
import Transition from 'react-transition-group/Transition';
import createStyles from "../createStyles";
var useStyles = createStyles(function () {
  return {
    content: {
      width: '100%',
      overflow: 'hidden',
      height: '0px'
    }
  };
}, {
  name: 'Collapse'
});
var Collapse = /*#__PURE__*/React.forwardRef(function Collapse(_ref, ref) {
  var children = _ref.children,
      show = _ref.show,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 200 : _ref$duration,
      onEntered = _ref.onEntered,
      onExited = _ref.onExited,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles();

  var handleEnter = function handleEnter(node, isAppearing) {
    if (isAppearing) {
      node.style.height = 'auto';
    } else {
      node.style.height = 0;
    }
  };

  var handleEntering = function handleEntering(node) {
    var height = node.scrollHeight;
    node.style.transitionDuration = "".concat(duration, "ms");
    node.style.height = "".concat(height, "px");
  };

  var handleEntered = function handleEntered(node, isAppearing) {
    node.style.height = 'auto';

    if (onEntered) {
      onEntered(node, isAppearing);
    }
  };

  var handleExit = function handleExit(node) {
    var height = node.scrollHeight;
    node.style.height = "".concat(height, "px");
  };

  var handleExiting = function handleExiting(node) {
    setTimeout(function () {
      node.style.transitionDuration = "".concat(duration, "ms");
      node.style.height = 0;
    }, 0);
  };

  return /*#__PURE__*/React.createElement(Transition, _extends({
    "in": show,
    ref: ref,
    appear: true,
    timeout: duration,
    onEnter: handleEnter,
    onEntering: handleEntering,
    onExit: handleExit,
    onExiting: handleExiting,
    onEntered: handleEntered,
    onExited: onExited
  }, props), /*#__PURE__*/React.createElement("div", {
    className: cn(classes.content, className)
  }, children));
});
Collapse.displayName = 'Collapse';
export default Collapse;